module.exports = __webpack_public_path__ + "03_mustache_black.1a07fa50.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/03_mustache_black.png
// module id = gVpE
// module chunks = 0